import { useTranslation } from "@i18n";
import AdNumber from "./components/adNumber/AdNumber";
import CashPayment from "./components/cashPayment/CashPayment";
import LimitedAvailability from "./components/limitedAvailability/LimitedAvailability";
import LabelsCA from "./components/labelsCA/LabelsCA";
import LessThanMarket from "./components/lessThanMarket/LessThanMarket";
import PaymentTabBox from "./components/paymentTabBox/PaymentTabBox";
import ShareNP from "./components/shareNP/ShareNP";
import stl from "./LeftColumn.module.css";
import useHelpers from "@hooks/useHelpers";

const LeftColumn = ({
  postData,
  mostPopular,
  ShowStory,
  setPaymentTypeFlag,
  titleForPaymentBox,
  isUsed,
  isTrackingView,
  isCancelled,
  g4_data,

}) => {
  const { t } = useTranslation(["web_post_view", "web_common"]);
  const { details, price, analytics, footer } = postData;
  const {createUrlAbsolute} = useHelpers();
  return (
    <>
      <div className={stl.container}>
        <div className="m-hide">
          <h1 className={stl.carName}>{details?.h1}</h1>
          {!isTrackingView && details?.low_mileage_text && (
            <LessThanMarket lowMileage={details?.low_mileage_text} />
          )}
          {!isTrackingView && <LabelsCA tags={details?.tags} />}
          {mostPopular && isTrackingView && (
            <hr style={{ border: "none", borderTop: "solid 1px #d8d8d8" }} />
          )}
          {!isTrackingView && (
            <>
              {details?.limited_quantity &&
              details?.details_card?.is_new?.id ? (
                <LimitedAvailability
                  priceSection={price}
                  postId={details?.id}
                  ShowStory={ShowStory}
                  post={details}
                  footer_section={footer}
                  g4_data={g4_data}
                  desktop
                  have_finance={details?.have_finance}
                />
              ) : details?.have_finance ? (
                <PaymentTabBox
                  isUsed={isUsed}
                  post={details}
                  priceSection={price}
                  postId={details?.id}
                  postTitle={details?.title}
                  analytic={analytics}
                  arboun={footer?.arboun}
                  reserved={footer?.reserved}
                  ShowStory={ShowStory}
                  setPaymentTypeFlag={setPaymentTypeFlag}
                  titleForPaymentBox={titleForPaymentBox}
                  desktop
                  g4_data={g4_data}
                  footer_section={footer}
                  car_condition={!(details?.details_card?.is_new.id)? "used": (details?.is_chinese)? "chinese" : "new"}
                />
              ) : (
                <CashPayment
                  priceSection={price}
                  postId={details?.id}
                  ShowStory={ShowStory}
                  arboun={footer?.arboun}
                  postTitle={details?.title}
                  reserved={footer?.reserved}
                  g4_data={g4_data}
                  footer_section={footer}
                />
              )}
            </>
          )}
          {isTrackingView && (
            <div className={stl.trackingPrice}>
              <div>
                <strong>{t("سعر الكاش", { ns: "web_post_view" })}</strong>
                <span
                  style={{
                    color:
                      !isCancelled || footer?.remaining_price <= 0
                        ? ""
                        : "#00B64E",
                  }}
                >
                  {footer?.total_price
                    ? footer?.total_price
                    : price?.vat_price?.text}
                  <span>
                    {t("ريال", {
                      ns: "web_post_view",
                    })}
                  </span>
                </span>
              </div>

              {isCancelled ? (
                <div>
                  <span className={stl.isCancelled}>
                    {" "}
                    {t("تم إلغاء الطلب", {
                      ns: "web_post_view",
                    })}
                  </span>
                </div>
              ) : footer?.remaining_price <= 0 ? (
                <div>
                  <span className={stl.fullypaid}>
                    {" "}
                    {t("مدفوع كاملاً", {
                      ns: "web_post_view",
                    })}
                  </span>
                </div>
              ) : (
                footer?.remaining_price && (
                  <div>
                    <strong>
                      {t("المبلغ المتبقي", { ns: "web_post_view" })}
                    </strong>
                    <span>
                      {footer?.remaining_price}
                      <span>
                        {t("ريال", {
                          ns: "web_post_view",
                        })}
                      </span>
                    </span>
                  </div>
                )
              )}
            </div>
          )}
          {!isTrackingView && (
            <ShareNP
              title={details?.title}
              postDynamicLink={createUrlAbsolute(`/cardetail/${details?.id}`)}
              postData={postData}
            />
          )}
          <AdNumber adNumber={details?.id} isTrackingView={isTrackingView} />
        </div>
      </div>
    </>
  );
};

export default LeftColumn;
